import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import {
    Box,
    Card,
    Loader,
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { DatoExportLog } from '@common/interfaces/api/bariatricsApi';
import { datoExportTypeOptions } from './datoUtils';

type DatoExportLogsTableProps = Readonly<{
    datoExportLogs: DatoExportLog[];
    isLoading: boolean;
    limit: number;
    onChangeLimit: (newLimit: number) => void;
    onChangePage: (newPage: number) => void;
    page: number;
    total: number;
}>;

export function DatoExportLogsTable(props: DatoExportLogsTableProps): JSX.Element {
    const { datoExportLogs, isLoading, limit, onChangeLimit, onChangePage, page, total } = props;

    if (isLoading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
            >
                <Loader />
            </Box>
        );
    }

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>Type activiteit</TableHeader>
                            <TableHeader>Maand</TableHeader>
                            <TableHeader>Datum export</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {datoExportLogs.map(({ exportDateTime, fromDate, id, type }) => (
                            <TableRow key={id}>
                                <TableCell fontWeight="medium">{datoExportTypeOptions[type].activityType}</TableCell>
                                <TableCell>
                                    {DateTime.from(fromDate).format('MMMM YYYY')} (
                                    {datoExportTypeOptions[type].monthType})
                                </TableCell>
                                <TableCell>{DateTime.from(exportDateTime).format('DD-MM-YYYY')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Card.Body>
                <Pagination
                    onChange={(params) => {
                        onChangeLimit(params.pageSize);
                        onChangePage(params.page);
                    }}
                    page={page}
                    pageSize={limit}
                    totalItems={total}
                />
            </Card.Body>
        </>
    );
}
